export const getSubject = (subject: string) => {
  return subject === "Mathematics" ? "MATH" : "READING";
};

export const getPercentileCategory = (percentile: number) => {
  let val = { color: "#81171A", text: "low", textColor: "#fafafa" };
  if (percentile >= 0.8) {
    val = { color: "#2876B6", text: "high", textColor: "#fafafa" };
  } else if (percentile >= 0.6) {
    val = { color: "#008753", text: "high avg", textColor: "#fafafa" };
  } else if (percentile >= 0.4) {
    val = { color: "#FFC62E", text: "mid", textColor: "#737373" };
  } else if (percentile >= 0.2) {
    val = { color: "#F78E23", text: "low avg", textColor: "#fafafa" };
  }

  return val;
};
